import React from 'react';
import CorreosTabla from 'pages/admin/Correos/CorreosTabla';
import { listEnviosCorreoGlobal, resumenEnviosCorreoGlobal } from 'api/enviosCorreo';

const CONSULTAS = { listar: listEnviosCorreoGlobal, resumen: resumenEnviosCorreoGlobal };

const COLUMNA_ORGANIZACION = [
  {
    title: 'Organización',
    dataIndex: 'tenantId',
    width: 140,
  },
];

export default function CorreosGlobalPage() {
  return (
    <CorreosTabla
      titulo="Correos de todas las organizaciones"
      consultas={CONSULTAS}
      columnasExtra={COLUMNA_ORGANIZACION}
    />
  );
}
